/** Best-effort human-readable message from a backend-service error. */
export function errText(err: unknown): string {
  return (
    (err as { error?: string; message?: string })?.error ??
    (err as Error)?.message ??
    'Something went wrong.'
  );
}
